// File Upload Component Handler
document.addEventListener('DOMContentLoaded', function() {
  const fileInputs = document.querySelectorAll('.file-upload-area input[type="file"]');
  
  fileInputs.forEach(input => {
    const dropzone = input.nextElementSibling;
    const uploadContent = dropzone.querySelector('.file-upload-content');
    const uploadPreview = dropzone.querySelector('.file-upload-preview');
    const previewName = dropzone.querySelector('.file-preview-name');
    const previewSize = dropzone.querySelector('.file-preview-size');
    const removeButton = dropzone.querySelector('.file-remove-button');
    
    // File input change handler
    input.addEventListener('change', function(e) {
      const file = e.target.files[0];
      if (file) {
        handleFileSelect(file);
      }
    });
    
    // Drag and drop handlers
    dropzone.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      dropzone.classList.add('drag-over');
    });
    
    dropzone.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      dropzone.classList.remove('drag-over');
    });
    
    dropzone.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      dropzone.classList.remove('drag-over');
      
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        // Validate file type
        const validTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        if (validTypes.includes(file.type)) {
          input.files = files;
          handleFileSelect(file);
        } else {
          alert('Please upload a PDF, JPG, or PNG file.');
        }
      }
    });
    
    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        uploadPreview.classList.remove('active');
        uploadPreview.style.display = 'none';
        uploadContent.style.display = 'flex';
      });
    }
    
    function handleFileSelect(file) {
      // Validate file size (10MB max)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        alert('File size must be less than 10MB.');
        input.value = '';
        return;
      }
      
      // Update preview
      if (previewName) previewName.textContent = file.name;
      if (previewSize) previewSize.textContent = formatFileSize(file.size);
      
      // Show preview, hide upload content
      if (uploadPreview) {
        uploadPreview.classList.add('active');
        uploadPreview.style.display = 'flex';
      }
      if (uploadContent) {
        uploadContent.style.display = 'none';
      }
    }
    
    function formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }
  });
});
